import axiosInstance from '@/plugins/axios';

export default class ServiceAdmin {
  static endpoint = 'admin';

  static digitalCertificate = {
    get: () => {
      return axiosInstance.get(`${this.endpoint}/certificate`);
    },
    associate: (data) => {
      return axiosInstance.post(`${this.endpoint}/company-config`, data);
    },
    historic: (id) => {
      return axiosInstance.get(`${this.endpoint}/company-config/certificate-history/${id}`);
    },
  };

  static company = {
    get: (params) => {
      return axiosInstance.get(`${this.endpoint}/company/search?${params}`);
    },
    fetchWithConfigs: (params) => {
      return axiosInstance.post(`${this.endpoint}/company/configs?${params}`);
    },
    saveConfigs: (companyId, payload) => {
      return axiosInstance.post(`${this.endpoint}/company/${companyId}/configs`, payload);
    },
    robotsHistory: (rootCnpj) => {
      return axiosInstance.get(`${this.endpoint}/company-config/robots/history/${rootCnpj}`);
    },
    upsertThirdPartyConfig: (rootCnpj, data) => {
      return axiosInstance.put(`${this.endpoint}/company-config/thirdy-party/${rootCnpj}`, data);
    },
  };

  static group = {
    get: () => {
      return axiosInstance.get(`${this.endpoint}/group/search`);
    },
    save: (grupo) => {
      return axiosInstance.post(`${this.endpoint}/group`, grupo);
    },
  };

  static empregadores = {
    getAll: (pagination) => {
      return axiosInstance.get(`${this.endpoint}/companyestab?${pagination}`);
    },
  };

  static establishment = {
    get: (params) => {
      return axiosInstance.get(`${this.endpoint}/establishment/search?${params}`);
    },
    sendMessageToQueue: (cnpj) => {
      return axiosInstance.get(`${this.endpoint}/establishment/sendmessagetoqueue?&cnpjEmpresaMatriz=${cnpj}`);
    },
  };

  static userEstablishment = {
    get: (id, onlyMatriz = false) => {
      return axiosInstance.get(
        `${this.endpoint}/user-establishment/findbyuserid/${id}${onlyMatriz ? '?onlyMatriz=true' : ''}`,
      );
    },
    save: (data) => {
      return axiosInstance.post(`${this.endpoint}/user-establishment`, data);
    },
    saveAll: (data, id) => {
      return axiosInstance.post(`${this.endpoint}/user-establishment/saveAll/${id}`, data);
    },
    delete: (id) => {
      return axiosInstance.delete(`${this.endpoint}/user-establishment/${id}`);
    },
  };

  static companyDetails = {
    saveCascade: (cnpj, groupId, data) => {
      return axiosInstance.post(`${this.endpoint}/company-details/save-cascade/${cnpj}/${groupId}`, data);
    },
  };

  static usability = {
    downloadUsabilityReport: (data) => {
      return axiosInstance.post(`${this.endpoint}/usability`, data, {
        responseType: 'arraybuffer',
        contentType: 'application/force-download',
        'Content-Disposition': 'attachment',
      });
    },
    findParams: (fromTime, toTime) => {
      return axiosInstance.get(`${this.endpoint}/usability/filters/${fromTime}/${toTime}`);
    },
  };

  static companyConfig = {
    getCurrentCertificate: (rootCnpj) => {
      return axiosInstance.get(
        `admin/company-config/${rootCnpj}/${'current_certificate'}`
      );
    },
    getCompanyConfig: (uuid) => {
      return axiosInstance.get(
        `admin/company/${uuid}/configs`
      );
    },
    getDctfEnabledCompanies: (companyIds) => {
      return axiosInstance.post('admin/company/configs/dctf-enabled', companyIds);
    },
  };
}
